//webSocket请求路径
const protocol = window.location.protocol === 'https:' ? 'wss://' : 'ws://';
let logMessagesUrl = protocol + window.location.hostname;
if (window.location.port !== '') {
    logMessagesUrl += ":" + window.location.port;
}
export default logMessagesUrl + '/api/system/websocket/'
